var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiRadio from '@mui/material/Radio';
import { FormControlLabel as BaseFormControlLabel } from '../form';
import { styled } from '../styled';
import clsx from '../utils/clsx';
import { radioClasses, getRadioUtilityClass, radioComponentName } from './radio-classes';
import { RadioCheckedIcon, RadioUncheckedIcon } from './radio-icons';
import { useMergedClasses } from '../styles/classes';
var RadioHeight = 18;
var RadioControl = styled(MuiRadio, { name: radioComponentName, slot: 'Radio' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    if (ownerState.hasLabelOrHelperText) {
        return {
            '&&': {
                paddingTop: 2,
            },
            height: theme.typography.pxToRem(RadioHeight),
            width: theme.typography.pxToRem(RadioHeight),
        };
    }
    return {
        padding: theme.spacing(1),
        height: theme.typography.pxToRem(34),
        width: theme.typography.pxToRem(34),
    };
});
var FormControlLabel = styled(BaseFormControlLabel, { name: radioComponentName, slot: 'FormControlLabel' })({});
export var Radio = React.forwardRef(function (props, ref) {
    var label = props.children, noWrap = props.noWrap, className = props.className, inputProps = props.inputProps, disabled = props.disabled, readOnly = props.readOnly, helperText = props.helperText, _a = props.HelperTextProps, HelperTextProps = _a === void 0 ? {} : _a, decoration = props.decoration, propClasses = props.classes, radioProps = __rest(props, ["children", "noWrap", "className", "inputProps", "disabled", "readOnly", "helperText", "HelperTextProps", "decoration", "classes"]);
    var classes = useMergedClasses(radioClasses, getRadioUtilityClass, propClasses);
    var isDisabled = disabled || readOnly;
    var hasLabelOrHelperText = !!helperText || !!label;
    var control = (React.createElement(RadioControl, __assign({ className: clsx(classes.radio, !hasLabelOrHelperText && className), ownerState: { hasLabelOrHelperText: hasLabelOrHelperText }, inputProps: inputProps, disabled: isDisabled, readOnly: readOnly, icon: React.createElement(RadioUncheckedIcon, { className: classes.iconUnchecked }), checkedIcon: React.createElement(RadioCheckedIcon, { className: classes.iconChecked }) }, radioProps, { ref: ref })));
    if (hasLabelOrHelperText) {
        return (React.createElement(FormControlLabel, { className: clsx(classes.formControlLabel, className), height: RadioHeight, label: label, helperText: helperText, HelperTextProps: HelperTextProps, decoration: decoration, noWrap: noWrap, disabled: isDisabled, control: control, ref: ref }));
    }
    return control;
});
